import { Component, OnInit, ViewChild } from '@angular/core';
const screenfull = require('screenfull');
const browser = require('jquery.browser');
declare var $: any;
const swal = require('sweetalert');

import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { Repository } from '../../services/repository'
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../shared/global';
import { environment } from '../../../environments/environment';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';

import { System_vaitro, System_nguoidung, System_thamso } from '../../routes/menu';
import { Http, RequestMethod, Request, Response } from "@angular/http";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @ViewChild('modal', { static: false }) modal: ModalComponent;
  @ViewChild('modalThongTinCaNhan', { static: false }) modalThongTinCaNhan: ModalComponent;
 thongtinlienhe_hoten: any;
  thongtinlienhe_sdt: any;
  profileUserName: string = null;
  profileDisplayName: string = null;
  profilePhone: string = null;
  profileAddress: string = null;
  profileEmail: string = null;
  profileSaving = false;
    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    username: string;
    isAuthentication: number;
    isNavSearchVisible: boolean;
    @ViewChild('fsbutton', {static: false}) fsbutton;  // the fullscreen button
   // @ViewChild('modalDoiMatKhau', {static: false}) modalDoiPass: BsModalComponent;
    returnUrl: string;
    vaitro: string = null;
    nguoidung: string = null;
    thamso: string = null;
    tendonvi: string = null;
    dschinhanhs: any = [];
    Nam: number;
    NamString: string = null;
    NgayHienTai: Date = new Date();
  public nams: Array<{ text: string, value: number }> = [

      { text: "Năm " + this.NgayHienTai.getFullYear().toString(), value: this.NgayHienTai.getFullYear() },
      { text: "Năm " + (this.NgayHienTai.getFullYear() - 1).toString(), value: (this.NgayHienTai.getFullYear() - 1) },
      { text: "Năm " +(this.NgayHienTai.getFullYear() - 2).toString(), value: (this.NgayHienTai.getFullYear() - 2) },
      { text: "Năm " +(this.NgayHienTai.getFullYear() - 3).toString(), value: (this.NgayHienTai.getFullYear() - 3) },
      { text: "Năm " +( this.NgayHienTai.getFullYear() - 4).toString(), value: (this.NgayHienTai.getFullYear() - 4) },
      
    { text: "Năm " +(this.NgayHienTai.getFullYear() + 1).toString(), value: (this.NgayHienTai.getFullYear() + 1) },
      //{ text: (this.NgayHienTai.getFullYear() + 2).toString(), value: (this.NgayHienTai.getFullYear() + 2) },
      //{ text: (this.NgayHienTai.getFullYear() + 3).toString(), value: (this.NgayHienTai.getFullYear() + 3) },

  ];
  currentApplicationVersion: any;
  trangthaiupdate: any;
    constructor(public menu: MenuService, public userblockService: UserblockService, public settings: SettingsService, private authenticationService: Repository, private route: ActivatedRoute, private router: Router) {
       
        settings.toggleLayoutSetting('asideToggled');
        
        this.currentApplicationVersion = environment.appVersion;
        this.vaitro = System_vaitro.id;
        this.nguoidung = System_nguoidung.id;
        this.thamso = System_thamso.id;
        // show only a few items on demo
        this.menuItems = menu.getMenu();//.slice(0,4); // for horizontal layout

        var currentUser1 = localStorage.getItem('currentUser');
        if (currentUser1) {

            let data = JSON.parse(currentUser1);
           // console.log(data);
          if (data != null) {
            this.username = data.user_name;
            this.tendonvi = data.ten_don_vi;
            this.isAuthentication = 1;
            this.Nam = data.nam_ke_toan;
            this.NamString = "Năm " + data.nam_ke_toan.toString();
          }
          else {
            this.isAuthentication = 0;
            this.Nam = this.NgayHienTai.getFullYear();
            this.NamString = "Năm " + this.NgayHienTai.getFullYear().toString();
          }
          this.nams = [
            { text: "Năm " + (this.Nam + 3).toString(), value: (this.Nam + 3) },
            { text: "Năm " + (this.Nam + 2).toString(), value: (this.Nam + 2) },
            { text: "Năm " + (this.Nam + 1).toString(), value: (this.Nam + 1) },
            { text: "Năm " + this.Nam.toString(), value: this.Nam },
            { text: "Năm " + (this.Nam - 1).toString(), value: (this.Nam - 1) },
            { text: "Năm " + (this.Nam - 2).toString(), value: (this.Nam - 2) },
            { text: "Năm " + (this.Nam - 3).toString(), value: (this.Nam - 3) },
            { text: "Năm " + (this.Nam - 4).toString(), value: (this.Nam - 4) },
            //{ text: (this.NgayHienTai.getFullYear() + 2).toString(), value: (this.NgayHienTai.getFullYear() + 2) },
            //{ text: (this.NgayHienTai.getFullYear() + 3).toString(), value: (this.NgayHienTai.getFullYear() + 3) },

          ];


            //this.authenticationService.getRequest('api/login/getchinhanh/')
            //    .subscribe(response => {
            //        this.dschinhanhs = response;
            //});

         
          let data1 = {
            Id: null,
            Type: null,
            Data: JSON.stringify({ UserName: this.username })
          };

          this.authenticationService.postRequest("api/danhmucchung/thongtinlienhe/", data1)
            .subscribe(response => {
              //response.length > 0
              if (response.length > 0) {
                this.thongtinlienhe_hoten = response[0].HoVaTen;
                this.thongtinlienhe_sdt = response[0].SoDienThoai;
              }
            });


      }

      authenticationService.postRequest('api/chungtu/getappversion', { Chuoi: this.currentApplicationVersion })
        .subscribe(response => {
          console.log(response);
          this.trangthaiupdate = response.Trang_Thai;
          
        });
       
    }
    reloadPage() {
        this.router.navigate([this.router.url]);
  }

  showHDSD() {

    this.modal.open();
  }


     valueChange(value): void {
     // this.Loaddatas();
      var currentUser1 = localStorage.getItem('currentUser');
      let data = JSON.parse(currentUser1);
      data.nam_ke_toan = value.value;
       this.Nam = value.value;
       this.NamString = "Năm " + value.value.toString();
       //localStorage.setItem('currentUser', JSON.stringify(data));



       //this.nams =[
       //  { text: "Năm " + this.Nam.toString(), value: this.Nam },
       //  { text: "Năm " + (this.Nam - 1).toString(), value: (this.Nam - 1) },
       //  { text: "Năm " + (this.Nam - 2).toString(), value: (this.Nam - 2) },
       //  { text: "Năm " + (this.Nam - 3).toString(), value: (this.Nam - 3) },
       //  { text: "Năm " + (this.Nam - 4).toString(), value: (this.Nam - 4) },

       //  { text: "Năm " + (this.Nam + 1).toString(), value: (this.Nam + 1) },
       //  { text: "Năm " + (this.Nam + 2).toString(), value: (this.Nam + 2) },
       //  { text: "Năm " + (this.Nam + 3).toString(), value: (this.Nam + 3) },
       //  //{ text: (this.NgayHienTai.getFullYear() + 2).toString(), value: (this.NgayHienTai.getFullYear() + 2) },
       //  //{ text: (this.NgayHienTai.getFullYear() + 3).toString(), value: (this.NgayHienTai.getFullYear() + 3) },

       //];

      window.location.reload();
    }
     
    changechinhanh(row) {
        this.tendonvi = row.Ten;
       
      this.authenticationService.getRequest('api/Login/doichinhanh/' + row.Id)
            .subscribe(response => {

              var currentUser1 = localStorage.getItem('currentUser');
              let data = JSON.parse(currentUser1);
              data.id_don_vi = row.Id;
              data.ten_don_vi = row.Ten;
             // localStorage.setItem('currentUser', JSON.stringify(data));
              window.location.reload();
            });
    }
    ngOnInit() {
        this.isNavSearchVisible = false;
        if (browser.msie) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }
  }
  generateCustomLink(): string {
    console.log("Xoa cookie trên Angular")
    localStorage.removeItem('currentUser');
    return '/Home/Logout';
  }

  logout() {
   
        console.log("Xoa cookie trên Angular")
    localStorage.removeItem('currentUser');
    //location.href = '/Home/Logout';
    window.location.reload();
    location.href = '/Home/Logout';
     // this.router.navigate(['/home']);
    //this.router.navigate(['/Home/Logout']);
        //this.authenticationService.logout();
        
        //this.router.navigate(['/home']);
  }
  lichsu() {
    this.router.navigate(['/danhmuc/history']);
  }
  capnhat() {
    this.router.navigate(['/danhmuc/capnhat']);
  }
    DoiMatKhau() { 
      this.router.navigate(['/quantri/doimatkhau']);
    }
    ThongTinCaNhan() {
      this.profileUserName = this.username;
      this.profileDisplayName = null;
      this.profilePhone = null;
      this.profileAddress = null;
      this.profileEmail = null;
      this.authenticationService.getRequest('api/login/thongtincanhan')
        .subscribe(res => {
          if (res && res.success) {
            this.profileUserName = res.userName || this.username;
            this.profileDisplayName = res.displayName;
            this.profilePhone = res.phone;
            this.profileAddress = res.address;
            this.profileEmail = res.email;
            this.modalThongTinCaNhan.open();
          } else {
            swal('Lỗi!', (res && res.message) || 'Không tải được thông tin tài khoản.', 'error');
          }
        }, () => {
          swal('Lỗi!', 'Không tải được thông tin tài khoản.', 'error');
        });
    }
    luuThongTinCaNhan() {
      if (!this.profileDisplayName || !String(this.profileDisplayName).trim()) {
        swal('Cảnh báo!', 'Tên hiển thị không được để trống.', 'warning');
        return;
      }
      if (!this.profileEmail || !String(this.profileEmail).trim()) {
        swal('Cảnh báo!', 'Email không được để trống.', 'warning');
        return;
      }

      this.profileSaving = true;
      const payload = {
        DisplayName: String(this.profileDisplayName).trim(),
        Phone: this.profilePhone ? String(this.profilePhone).trim() : null,
        Address: this.profileAddress ? String(this.profileAddress).trim() : null,
        Email: String(this.profileEmail).trim()
      };

      this.authenticationService.postRequest('api/login/capnhatthongtin', payload)
        .subscribe(res => {
          this.profileSaving = false;
          if (res && res.success) {
            try {
              const currentUser = JSON.parse(localStorage.getItem('currentUser'));
              if (currentUser) {
                currentUser.displayName = res.displayName || payload.DisplayName;
                localStorage.setItem('currentUser', JSON.stringify(currentUser));
              }
            } catch { }
            this.modalThongTinCaNhan.close();
            swal('Thành công!', res.message || 'Đã cập nhật thông tin.', 'success');
          } else {
            swal('Cảnh báo!', (res && res.message) || 'Không cập nhật được.', 'warning');
          }
        }, () => {
          this.profileSaving = false;
          swal('Lỗi!', 'Không cập nhật được thông tin.', 'error');
        });
    }
    toggleUserBlock(event) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.layout.offsidebarOpen = !this.settings.layout.offsidebarOpen;
    }

    toggleCollapsedSideabar() {
        this.settings.layout.isCollapsed = !this.settings.layout.isCollapsed;
    }

    isCollapsedText() {
        return this.settings.layout.isCollapsedText;
    }

    toggleFullScreen(event) {

        if (screenfull.enabled) {
            screenfull.toggle();
        }
        // Switch icon indicator
        let el = $(this.fsbutton.nativeElement);
        if (screenfull.isFullscreen) {
            el.children('em').removeClass('fa-expand').addClass('fa-compress');
        }
        else {
            el.children('em').removeClass('fa-compress').addClass('fa-expand');
        }
    }
}
